<template>
  <Card container-class="card shadow-sm" :title="$t('events.nps.new')">
    <template #cardToolbar>
      <Button type="cancel" id="cancel_btn" btn-class="btn-sm" btn-text="back" @click="backList"></Button>
    </template>
    <template #cardBody>
      <NpsForm :default-form="defaultForm" :submit-form="storeNewNps" :loading="loading" :title="$t('events.nps.new')"/>
    </template>
  </Card> 
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import NpsForm from "../../components/NpsForm.vue";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import Card from "@/components/Card.vue";
import Button from "@/components/Button.vue";

const store = useStore()
const route = useRoute()
const router = useRouter()

const company = computed(() => store.getters['offices/getSelectedCompany'])

const loading = ref(false)
const defaultForm = ref({
  title:"",
  name:"",
  nps_description:"",
  icon:"",
  society_id:"",
  min_value: 1,
  max_value:10,
  fields: [],
  participator_type: '',
  all_type: false
}) 

watch(() => route.query.tab, (value) => {
    if(value == 'tab-nps') {
      loadFieldTypes()
    }
})

function storeNewNps({data, submit}){
  loading.value = true
  store.dispatch('eventNps/createNps', {...data, society_id: company?.value.id, name: data?.title, event_id: route.params.id})
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.nps_created"))
        if(submit){
          backList()
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

const backList = () => {
  router.push({ name: 'events-nps-index', params: { id: route.params.id }, query: { tab: route.query.tab || 'tab-nps' } });
}

onMounted(() => {
  if(route.query.tab == 'tab-nps') loadFieldTypes()
})

</script>

<style scoped>
.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

#eye-icon {
  font-size: 1.2em;
}
</style>
